module.exports = __webpack_public_path__ + "img/logo-dark-short.05dbf7ad.png";